module.exports = __webpack_public_path__ + "static/women-laughing.0470d28b.jpg";